/**
 * Regular expressions to determine if the user is in a WebView.
 *
 * Taken from {@link https://github.com/atomantic/is-ua-webview/blob/main/data/rules.js is-ua-webview}.
 */
const WEBVIEW_REGEXP_RULES = [
  // If it says it's a WebView, let's go with that
  'WebView',
  // iOS webview will be the same as safari but missing "Safari"
  '(iPhone|iPod|iPad)(?!.*Safari)',
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
  'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
  // old chrome android webview agent
  'Linux; U; Android',
  // Some other explicit cases for good measure
  'Instagram',
  'LinkedIn',
];

/**
 * Determines whether the user agent string indicates that the user is in a WebView.
 *
 * It is case-insensitive.
 *
 * @param userAgent - The user agent string to check.
 * @returns `true` if the user is in a WebView, `false` otherwise.
 */
export const isUserAgentWebView = (userAgent: string) => {
  const regex = new RegExp(WEBVIEW_REGEXP_RULES.map(String).join('|'), 'ig');
  return regex.test(userAgent);
};
